<template>
  <UsersReport
      :items="items"
      @updated="onUpdate"
  />
</template>

<script>
import {
  LAYOUT_LOADING_START,
  LAYOUT_LOADING_STOP,
  LAYOUT_TITLE_CHANGED
} from "@/store/modules/layout/actions";
import UsersReport from "@/components/report/DeliveryStatistics/UsersReportComponent.vue"
import ReportService from "@/services/report.service"
import _ from "underscore"
import Moment from "moment";
import {AllowOperatorsStatistics} from "@/enums/permission";

export default {
  name: "UsersReportView",
  components: {
    UsersReport
  },
  data() {
    return {
      items: []
    };
  },
  computed: {
    isAllowUserStatistics() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowOperatorsStatistics
      })
    },
  },
  methods: {
    onUpdate(filters) {
      const {start, end, date, region, selectedFilters, postIndex, isAllClientsSelected, type} = filters;

      this.$store.dispatch(LAYOUT_LOADING_START)
      ReportService.getUsersReport({
        client: this.$store.getters.appActiveClient,
        start: start ? Moment(start, "YYYY-MM-DD") : null,
        end: end ? Moment(end, "YYYY-MM-DD") : null,
        regionId: region?.id,
        date: date ? Moment(date, "YYYY-MM") : null,
        selectedFilters: selectedFilters ? selectedFilters : null,
        type: type,
        postIndex: postIndex ? postIndex : null,
        isAllClientsSelected: isAllClientsSelected
      })
          .then(response => {
            this.items = _.map(response.data, a => {
              return {
                PostIndexCode: a.PostIndexCode,
                AccountName: a.AccountName,
                AccountType: a.AccountType,
                DeliveredBeforeTime: a.DeliveredBeforeTime,
                DeliveredAfterTime: a.DeliveredAfterTime,
                DeliveredCount: a.DeliveredCount,
                ReturnedBeforeTime: a.ReturnedBeforeTime,
                ReturnedAfterTime: a.ReturnedAfterTime,
                ReturnedCount: a.ReturnedCount,
                BeforeTimeEnteredInformation: a.BeforeTimeEnteredInformation,
                AfterTimeEnteredInformation: a.AfterTimeEnteredInformation,
                EnteredInformationCount: a.EnteredInformationCount
              }
            })
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    }
  },
  created() {
    if (this.isAllowUserStatistics)
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, "Статистика пользователей")
    else
      this.$router.go(-1)
  }
}
</script>